import React from 'react';
import './aboutus.css';

function AboutUs() {
  return (
    <div className="aboutus-container">
      <div className="aboutus-hero">
        <div className="aboutus-hero-content">
          <h1>About Penny</h1>
          <p>Helping you save money and reduce food waste, one shopping trip at a time.</p>
        </div>
      </div>

      <div className="aboutus-section">
        <div className="aboutus-content">
          <div className="aboutus-story">
            <div className="aboutus-text">
              <h2>Our Story</h2>
              <p>
                Penny was born from a simple observation: people were spending too much on groceries and wasting too much food. 
                In 2023, a team of passionate developers and economists came together with a mission to create a solution that would 
                help households optimize their grocery shopping while reducing food waste.
              </p>
              <p>
                What started as a small project has grown into a comprehensive platform that connects users with the best deals 
                from local stores and provides intelligent planning tools to make the most of every purchase.
              </p>
            </div>
            <div className="aboutus-image">
              <img src="/Images/about-story.jpg" alt="Penny team working together" />
            </div>
          </div>
        </div>
      </div>

      <div className="aboutus-section aboutus-mission-section">
        <div className="aboutus-content">
          <div className="aboutus-mission">
            <div className="aboutus-image">
              <img src="/Images/about-mission.jpg" alt="Sustainable shopping" />
            </div>
            <div className="aboutus-text">
              <h2>Our Mission</h2>
              <p>
                At Penny, we believe that smart shopping shouldn't be complicated. Our mission is to empower consumers 
                to make informed decisions that benefit both their wallets and the planet.
              </p>
              <p>
                By aggregating deals from various stores and providing intelligent meal planning tools, we help our users:
              </p>
              <ul>
                <li>Save up to 30% on their grocery bills</li>
                <li>Reduce household food waste by 25%</li>
                <li>Make more sustainable shopping choices</li>
                <li>Simplify their weekly meal planning</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* for later use

      <div className="aboutus-section">
        <div className="aboutus-content">
          <h2 className="team-heading">Meet Our Team</h2>
          <p className="team-subheading">The passionate people behind Penny</p>
          
          <div className="team-grid">
            <div className="team-member">
              <div className="team-photo">
                <img src="/Images/team-1.jpg" alt="Team member" />
              </div>
              <h3>Marco Sagredo</h3>
              <p className="team-role">Founder & CEO</p>
              <p className="team-bio">With a background in economics and engineering, Marco leads our vision for a more efficient grocery ecosystem.</p>
            </div>
            
            <div className="team-member">
              <div className="team-photo">
                <img src="/Images/team-2.jpg" alt="Team member" />
              </div>
              <h3>Sofia Hagberg</h3>
              <p className="team-role">Head of Strategy & Communication</p>
              <p className="team-bio">Sofia brings experience in strategy consulting and a passion for creating intuitive user experiences.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="aboutus-section aboutus-values-section">
        <div className="aboutus-content">
          <h2>Our Values</h2>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <h3>Sustainability</h3>
              <p>We're committed to reducing food waste and promoting environmentally conscious shopping habits.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-hand-holding-usd"></i>
              </div>
              <h3>Affordability</h3>
              <p>We believe everyone deserves access to quality food at reasonable prices.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation</h3>
              <p>We continuously improve our platform with new features and smarter algorithms.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Community</h3>
              <p>We foster a community of smart shoppers who share tips and support each other.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="aboutus-section">
        <div className="aboutus-content">
          <div className="aboutus-impact">
            <div className="aboutus-text">
              <h2>Our Impact</h2>
              <p>
                Since our launch, Penny has helped thousands of users transform their shopping habits:
              </p>
              
              <div className="impact-stats">
                <div className="impact-stat">
                  <span className="impact-number">€2.5M+</span>
                  <span className="impact-label">Saved by our users</span>
                </div>
                
                <div className="impact-stat">
                  <span className="impact-number">15,000+</span>
                  <span className="impact-label">Active monthly users</span>
                </div>
                
                <div className="impact-stat">
                  <span className="impact-number">30%</span>
                  <span className="impact-label">Average reduction in food waste</span>
                </div>
              </div>
              
              <p>
                We're proud of these numbers, but we're just getting started. Our goal is to expand 
                to more regions and help even more people shop smarter and waste less.
              </p>
            </div>
            <div className="aboutus-image">
              <img src="/Images/about-impact.jpg" alt="Penny app impact" />
            </div>
          </div>
        </div>
      </div>
      */}

      <div className="aboutus-section aboutus-cta-section">
        <div className="aboutus-content">
          <div className="aboutus-cta">
            <h2>Join the Penny Community</h2>
            <p>Start saving money and reducing waste today.</p>
            <button className="aboutus-cta-button" onClick={() => window.location.href = '/login'}>
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
